module.exports = __webpack_public_path__ + "img/whoop.3870569b.png";